import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import type { RecordFiltersState } from '../../hooks/useRecordFilters';
import FilterDialog from '../FilterDialog/FilterDialog';

interface RecordFilterDialogProps {
    open: boolean;
    onClose: () => void;
    filters: RecordFiltersState;
    // Called after the filters are applied or reset, e.g. to jump back to page 1.
    onChanged: () => void;
    // Translation prefix for the dialog's labels, e.g. 'Pending.Filter'.
    tKey: string;
}

/** FilterDialog bound to a record table's draft and applied filters (see useRecordFilters). */
function RecordFilterDialog({ open, onClose, filters, onChanged, tKey }: RecordFilterDialogProps) {
    const finish = (action: () => void) => () => {
        action();
        onChanged();
        onClose();
    };

    return (
        <FilterDialog
            open={open}
            onClose={onClose}
            onApply={finish(filters.apply)}
            onReset={finish(filters.reset)}
            startPicker={<DatePicker value={filters.startTime} onChange={filters.handleStartTimeChange} />}
            endPicker={<DatePicker value={filters.endTime} onChange={filters.handleEndTimeChange} />}
            statusFilter={filters.statusFilter}
            onStatusChange={filters.setStatusFilter}
            deviceTypeFilter={filters.deviceTypeFilter}
            onDeviceTypeChange={filters.setDeviceTypeFilter}
            durationRange={filters.durationRange}
            onDurationChange={filters.setDurationRange}
            labelFilter={filters.labelFilter}
            onLabelChange={filters.setLabelFilter}
            tKey={tKey}
        />
    );
}

export default RecordFilterDialog;
